import { faEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons/faEllipsisVertical';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import styles from './ThreeDotsDropdown.module.scss';
import ThreeDotsDropdownList from './ThreeDotsDropdownList';
import { ThreeDotsDropdownOption } from './ThreeDotsDropdownOption';

interface ThreeDotsDropdownProps {
    options: Array<ThreeDotsDropdownOption>;
    direction: 'up' | 'down';
    className?: string;
    usePortal?: boolean;
}

export const ThreeDotsDropdown: FunctionComponent<ThreeDotsDropdownProps> = props => {
    const [expanded, setExpanded] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // A portaled menu lives outside containerRef, so this guard would close it before the item's click lands.
        if (props.usePortal) return;

        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            if (expanded && containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [expanded, props.usePortal]);

    return props.options.length > 0 ? (
        <div
            ref={containerRef}
            className={clsx(styles.container, props.className)}
            onClick={() => setExpanded(prev => !prev)}
        >
            <FontAwesomeIcon icon={expanded ? faEllipsisVertical : faEllipsis} />
            {expanded && (
                <ThreeDotsDropdownList
                    options={props.options}
                    onClose={() => setExpanded(false)}
                    direction={props.direction}
                    usePortal={props.usePortal}
                    triggerRef={containerRef}
                />
            )}
        </div>
    ) : null;
};

export default ThreeDotsDropdown;
